import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { IonPopover } from '@ionic/angular';
import { AIAssistantAnswer } from 'src/app/task-process/shared/models/ai-assistant-answer.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ai-assistant-suggestion-knowledge-documents',
  templateUrl: './ai-assistant-suggestion-knowledge-documents.component.html',
  styleUrls: ['./ai-assistant-suggestion-knowledge-documents.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AiAssistantSuggestionKnowledgeDocumentsComponent {
  @Input() suggestion: AIAssistantAnswer;

  @ViewChild('popover') popover: IonPopover;

  isPopoverDisplayed = false;
  bundledWithAngularJSApp = environment.bundledWithAngularJSApp;

  displayedKdPopover(event: Event) {
    this.popover.event = event;
    this.isPopoverDisplayed = true;
  }
}
